import common from './common.json'
import showcaseAnnual from './schemes/showcase-annual.json'
import showcaseDriveaway from './schemes/showcase-driveaway.json'
import showcaseFlex from './schemes/showcase-flex.json'

export default {
  common,
  'showcase-driveaway': showcaseDriveaway,
  'showcase-flex': showcaseFlex,
  'showcase-annual': showcaseAnnual,
}
